import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonToggleContainerComponent } from './button-toggle-container.component';

@NgModule({
	declarations: [ButtonToggleContainerComponent],
	imports: [CommonModule, FormsModule],
	exports: [ButtonToggleContainerComponent]
})
export class WmButtonToggleContainerModule {}
